
export default {
    productData: {
        serialNumber: 'DA-HMS-012',
        name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 12',
        construction: {
        composition: [
            {
            type: 'screed',
            title: { de: 'Estrich' },
            output: 'ohne',
            value: 'nw-0'
            },
            {
            type: 'soundInsulation',
            title: { de: 'Schalldämmplatte' },
            output: '2 x 15 mm',
            value: 'si-30'
            },
            {
            type: 'insulation',
            title: { de: 'Holzfaserdämmplatte' },
            output: '≥ 20',
            value: 'w-20'
            },
            {
            type: 'fill',
            title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz' },
            output: '≥ 80',
            value: 'scsb-80'
            },
            {
            type: 'woodenPanel',
            title: { de: 'Holzwerkstoffplatte HW' },
            output: '≥ 22',
            value: 22
            },
            {
            type: 'supportingStructure',
            title: { de: 'Balken' },
            output: '240',
            value: 'b-240'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Hohlraumdämpfung' },
                output: '2 x 120',
                value: 'h-240'
              },
            {
            type: 'suspendedCeiling',
            title: { de: 'Federschiene' },
            output: '25',
            value: 'f-25'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Gipsplatte GKFI' },
                output: '12,5',
                value: 'g-12.5'
              }
        ],
        sum: {
            output: '430', value: 430
        }
        },
        technicalValues: {
        impactSoundLevel: { // L,nw
            output: '37 (2; 13)',
            value: 37
        },
        soundReductionIndex: { // Rw
            output: '81 (-5; -12)',
            value: 81
        },
        heatTransferCoefficient: { // U-Wert
            output: '0,18',
            value: 0.18
        },
        fireResistance: {
          output: '-', value: null
        },
        massPerUnitArea: {
          output: '232,2 [kg/m²]'
        }
        }
    },
    image: 'da-hms-012.png',
    pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-12-DA-HMS-012-Rev01.pdf'
    }
  
